import { render } from "./Searchbox.vue?vue&type=template&id=4bdf2675"
import script from "./Searchbox.vue?vue&type=script&lang=js"
export * from "./Searchbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__